import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './LandingPage';
import PhysicalAIData from './PhysicalAIData';
import './font.css';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/physicalaidata" element={<PhysicalAIData />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
